/* eslint-disable import/prefer-default-export */
export const URL_SEND = "/g4noauth/actions/SendAuthorizationRequest";
